import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCandidate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.85156 15C5.15625 15 2.69531 13.5938 1.34766 11.25C0 8.93555 0 6.09375 1.34766 3.75C2.69531 1.43555 5.15625 0 7.85156 0C10.5176 0 12.9785 1.43555 14.3262 3.75C15.6738 6.09375 15.6738 8.93555 14.3262 11.25C12.9785 13.5938 10.5176 15 7.85156 15ZM7.85156 4.6875C6.82617 4.6875 5.91797 5.24414 5.39062 6.09375C4.89258 6.97266 4.89258 8.05664 5.39062 8.90625C5.91797 9.78516 6.82617 10.3125 7.85156 10.3125C8.84766 10.3125 9.75586 9.78516 10.2832 8.90625C10.7812 8.05664 10.7812 6.97266 10.2832 6.09375C9.75586 5.24414 8.84766 4.6875 7.85156 4.6875Z",
		fill: "#A3A3A3"
	})
});
export default SvgCandidate;
